import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { container, item, inView } from "../service/presets";

export default function ArticleBlocks({ blocks }) {
  return (
    <motion.div {...inView} variants={container}>
      {blocks.map((b, i) => {
        if (b.h4 !== undefined)
          return (
            <motion.h2 key={i} variants={item} className="font-display mt-11 first:mt-0 text-xl md:text-2xl font-bold text-white leading-snug">
              {b.h4}
            </motion.h2>
          );
        if (b.ul !== undefined)
          return (
            <motion.ul key={i} variants={item} className="mt-5 grid gap-3">
              {b.ul.map((li, k) => (
                <li key={k} className="flex items-start gap-3 rq-card p-4">
                  <span className="grid place-items-center h-6 w-6 rounded-full bg-[rgba(14,122,58,0.15)] text-[color:var(--rq-green)] shrink-0 mt-0.5">
                    <Check size={13} />
                  </span>
                  <span className="text-sm md:text-[15px] leading-relaxed text-white">{li}</span>
                </li>
              ))}
            </motion.ul>
          );
        return (
          <motion.p key={i} variants={item} className="mt-4 text-[15px] md:text-[17px] leading-[1.9] text-[color:var(--rq-muted)]">
            {b.p}
          </motion.p>
        );
      })}
    </motion.div>
  );
}
